import { type CSSProperties, memo } from "react";
import { useSelector } from "react-redux";
import { type GroupedCartEntry } from "../../../../models/CartData";
import { ProductType } from "../../../../../models/ProductData";
import PlainProductEntry from "./PlainProductEntry";
import { KitProductEntry } from "~/Cart/components/CartPage/ProductTable/ProductEntryList/KITProductEntry/KitProductEntry";
import {
  compareRGCEEquality,
  selectResolvedGroupedEntry,
} from "~/Cart/components/CartPage/ProductTable/ProductEntryList/productEntryHelper";

export interface ProductEntryProps {
  groupingEntry: GroupedCartEntry;
  className?: string;
  editMode?: boolean;
  index: number;
  style?: CSSProperties;

  onRender: (element: Element) => void;
}

const ProductEntry = (props: ProductEntryProps) => {
  const resolvedEntry = useSelector(selectResolvedGroupedEntry(props.groupingEntry), compareRGCEEquality);

  const product = resolvedEntry.descriptors[0];
  switch (product.base.type) {
    case ProductType.DEFAULT:
    case ProductType.CONFIGURATOR:
      return <PlainProductEntry {...props} groupingEntry={resolvedEntry} />;

    case ProductType.KIT:
      return <KitProductEntry {...props} groupingEntry={resolvedEntry} />;

    default:
      throw new Error("Not implemented");
  }
};

export default memo(ProductEntry);
